import React, {Component, PureComponent} from 'react';
import {ListView} from 'antd-mobile';

import {connect} from 'react-redux';
import {createOrder} from './store/actionCreators';

class Order extends PureComponent {

    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
        };
    }

    render() {

        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 8,
                    borderTop: '1px solid #ECECED',
                    borderBottom: '1px solid #ECECED',
                }}
            />
        );

        const {chargeList = []} = this.props.userChargeList;
        let {dataSource} = this.state;
        let index = chargeList.length - 1;

        const row = (rowData, sectionID, rowID) => {
            if (index < 0) {
                index = chargeList.length - 1;
            }
            const obj = chargeList[index--];
            return (
                <div key={rowID} style={{padding: '0 15px'}} data-id={obj.id}>
                </div>
            );
        };


        return (
            <ListView
                ref={el => this.lv = el}
                dataSource={this.state.dataSource}
                renderFooter={() => (<div style={{padding: 30, textAlign: 'center'}}>
                    {this.state.isLoading ? '加载中...' : '加载完成'}
                </div>)}
                renderRow={row}
                renderSeparator={separator}
                className="am-list"
                pageSize={4}
                useBodyScroll
                onScroll={() => {
                    console.log('scroll');
                }}
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
            />
        )

    }
}

const mapStateToProps = (data) => {
    return {
        createOrder: data
    }
};

const mapDispatchToProps = (dispatch) => ({
    createOrder: (param) => dispatch(createOrder(param)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Order);